var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu_closenblack_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61392",
    "data-name": "Path 61392",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61393",
    "data-name": "Path 61393",
    d: "M3,18H15.016V16H3Zm0-5h9.2V11H3ZM3,6V8H15.016V6Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61407",
    "data-name": "Path 61407",
    d: "M19.605,6.827l-4.59,4.4,4.59,4.841",
    transform: "translate(1 0.672)",
    fill: "none",
    stroke: "#808080",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentHide);
export default __webpack_public_path__ + "static/media/ContentHide.9f41d9b2bbd7d95598e1d77979ff6695.svg";
export { ForwardRef as ReactComponent };